module.exports = __webpack_public_path__ + "media/npc_dota_hero_jakiro.8573f660.webm";